import type { Doc } from "building-types/doc";
import type { CatalogItemHandle } from "building-types/handles/docEntityHandleTypes";
import { docGetCachedCatalogItemTableFieldName } from "./docGetCatalogItem";

/**
 * Provides the name of the field that is used to store a catalog item on a catalog settings object. For instance,
 * window catalog items are stored on `WindowCatalogSettings.windowTypes` so this function would return "windowType"
 * for such an item. Some catalogs have multiple such tables. In that case, this function uses the itemId to determine
 * which one to return.
 */
export function docGetCatalogItemTableFieldName(doc: Doc, handle: CatalogItemHandle): string | undefined {
  return docGetCachedCatalogItemTableFieldName(doc, handle);
}
